import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ApplicationService } from '@/app/application.service';
import { APPLICATION_ACTIONS, ApplicationActions } from '@core/actions/types';
import { SupportContextService } from '@/app/support/support-context.service';

@Component({
  selector: 'application-info',
  templateUrl: './application-info.component.html',
  styleUrls: ['./application-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ApplicationInfoComponent {
  constructor(
    readonly appService: ApplicationService,
    @Inject(APPLICATION_ACTIONS)
    private readonly applicationActions: ApplicationActions,
    supportContext: SupportContextService
  ) {
    this.resolution = supportContext.screenSize();
    this.viewport = supportContext.viewportSize();
  }

  readonly userAgent = navigator.userAgent;
  readonly resolution: string;
  readonly viewport: string;

  restart(): void {
    this.applicationActions.resetApplication();
  }
}
